export const CONST = {
    // BACKEND_URL: 'https://bckpkcnliv.parkchain.org/'
    // BACKEND_URL: 'http://172.16.16.106:6400/'
    BACKEND_URL:'https://metprkbknd.metapark.app/'

}